(function () {
  function setup(root) {
    const carousels = [];
    if (root.matches && root.matches('novari-photo-carousel')) carousels.push(root);
    if (root.querySelectorAll) carousels.push(...root.querySelectorAll('novari-photo-carousel'));

    carousels.forEach(function (carousel) {
      if (carousel.dataset.initialized === 'true') return;
      const track = carousel.querySelector('.nc-home-photos__track');
      const previous = carousel.querySelector('[data-nc-dir="-1"]');
      const next = carousel.querySelector('[data-nc-dir="1"]');
      if (!track || !previous || !next) return;

      carousel.dataset.initialized = 'true';
      const slides = Array.from(track.querySelectorAll('.nc-home-photos__slide'))
        .filter(function (slide) { return !slide.classList.contains('nc-home-photos__placeholder'); });
      if (!slides.length) return;

      const intervalMs = Math.max(3000, Math.min(10000, Number(carousel.dataset.intervalMs) || 5000));
      const shouldAutoplay = carousel.dataset.autoplay === 'true' && slides.length > 1;
      const reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      let current = 0;
      let pauseUntil = 0;
      let interval = null;

      function metrics() {
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const distance = slides[0].getBoundingClientRect().width + gap;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const last = distance ? Math.max(0, Math.round(maxScroll / distance)) : 0;
        return { distance: distance, last: last };
      }

      function updateControls() {
        const m = metrics();
        const disabled = m.last === 0;
        previous.disabled = disabled;
        next.disabled = disabled;
        previous.setAttribute('aria-disabled', String(disabled));
        next.setAttribute('aria-disabled', String(disabled));
      }

      function navigate(direction, fromUser) {
        const m = metrics();
        if (!m.distance || m.last === 0) return;
        if (fromUser) pauseUntil = Date.now() + 6500;
        let nextIndex = current + direction;
        let wrap = false;
        if (nextIndex > m.last) { nextIndex = 0; wrap = true; }
        if (nextIndex < 0) { nextIndex = m.last; wrap = true; }
        current = nextIndex;
        track.scrollTo({ left: m.distance * current, behavior: (reduceMotion || wrap) ? 'instant' : 'smooth' });
        updateControls();
      }

      previous.addEventListener('click', function () { navigate(-1, true); });
      next.addEventListener('click', function () { navigate(1, true); });

      // Only pause after a deliberate swipe/drag, not because the pointer is resting on the gallery.
      track.addEventListener('pointerdown', function () { pauseUntil = Date.now() + 6500; }, { passive: true });
      track.addEventListener('touchstart', function () { pauseUntil = Date.now() + 6500; }, { passive: true });
      track.addEventListener('scroll', function () {
        const m = metrics();
        if (m.distance) current = Math.min(m.last, Math.max(0, Math.round(track.scrollLeft / m.distance)));
      }, { passive: true });

      if (shouldAutoplay && !reduceMotion) {
        interval = window.setInterval(function () {
          if (!document.hidden && Date.now() >= pauseUntil) navigate(1, false);
        }, intervalMs);
      }

      window.addEventListener('resize', function () {
        const m = metrics();
        current = Math.min(current, m.last);
        track.scrollTo({ left: current * m.distance, behavior: 'instant' });
        updateControls();
      });

      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target.contains(carousel) && interval) window.clearInterval(interval);
      });
      updateControls();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(document); });
  else setup(document);
  document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
})();